import { Button, StatusSwitch } from 'streamlabs-beaker';
import { IScene } from '@/helpers/editor';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import CreateSceneModal from '@/components/editor/modals/CreateSceneModal.vue';
import { EModalName } from '@/helpers/modal';
import SceneMixins from '../scenes/SceneMixins';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import Tooltip from '@/components/utils/Tooltip.vue';
import HorizontalScroll from 'vue-horizontal-scroll';
import Vue from 'vue';
import TransitionLibraryModal from '@/components/editor/modals/TransitionLibraryModal.vue';
import { VPopover } from 'v-tooltip';
import UserApi from '@/apis/user-api';

const ADD_SCENE_BUTTON_WIDTH = 104;
const SCENE_SECTION_PADDINGS = 32;
const TRANSITION_BAR_WIDTH = 40;

@Component({
  components: {
    CreateSceneModal,
    SButton: Button,
    ConfirmationModal,
    Tooltip,
    HorizontalScroll,
    SStatusSwitch: StatusSwitch,
    TransitionLibraryModal,
    VPopover,
  },
})
export default class SceneSection extends Mixins(SceneMixins) {
  hasMoreSceneThanContainer: boolean = false;
  sceneIsLoading: boolean = false;
  shouldDisplaySceneTransitionTooltip: boolean = false;
  shouldDisplaySaveTooltip: boolean = false;
  sceneContainerCanScrollBack: boolean = false;

  $refs: {
    sceneContainer: Vue;
  };

  get scenes(): IScene[] {
    if (!this.selectedProject?.scenes) return [];

    return this.selectedProject.scenes;
  }

  async mounted() {
    this.calculateWidth();
    window.addEventListener('resize', this.calculateWidth);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.calculateWidth);
  }

  @Watch('hasUnsavedChange')
  handler() {
    if (this.hasUnsavedChange && this.showSaveButtonTooltip) this.shouldDisplaySaveTooltip = true;
  }

  @Watch('scenes')
  calculateWidth() {
    // width + margin
    const singleSceneWidth = 163 + 16;

    if (
      this.$refs.sceneContainer?.$el.clientWidth <
      singleSceneWidth * this.scenes.length + ADD_SCENE_BUTTON_WIDTH + SCENE_SECTION_PADDINGS + (this.hasTransition ? TRANSITION_BAR_WIDTH : 0)
    ) {
      this.hasMoreSceneThanContainer = true;
    } else {
      this.hasMoreSceneThanContainer = false;
    }
  }

  @Watch('hasTransition')
  showSceneTransitionTooltip() {
    if (this.hasTransition && !this.userFlags.transition_tooltip_shown)
      this.shouldDisplaySceneTransitionTooltip = true;
  }

  onCreateSceneClick() {
    this.$modal.show(EModalName.createScene);
  }

  onSceneClick(scene: IScene) {
    if (this.selectedScene && this.selectedScene.id === scene.id) return;

    this.selectedScene = scene;
  }

  dismissTooltip() {
    this.shouldDisplayActivateSceneTooltip = false;
  }

  dismissSceneTransitionTooltip() {
    this.shouldDisplaySceneTransitionTooltip = false;
    UserApi.setTransitionTooltipShown();
  }

  updateActiveScene(scene: IScene = this.selectedScene) {
    this.setSceneAsActive(scene);
  }

  scrollSceneContainer(scrollByX = 100) {
    this.$refs.sceneContainer.$el.scrollBy(scrollByX, 0);
    this.sceneContainerCanScrollBack = !!this.$refs.sceneContainer.$el.scrollLeft;
  }
}
